import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Providers } from './providers';
import { Router } from './router';
import Layout from './layouts/Layout';

/**
 * QueryClient configuration with production-ready defaults
 *
 * - staleTime: 5 minutes - Data is considered fresh for 5 minutes
 * - gcTime: 10 minutes - Unused cache data is garbage collected after 10 minutes
 * - retry: 1 - Only retry failed requests once to avoid hammering failing endpoints
 * - refetchOnWindowFocus: false - Don't refetch when window regains focus (performance)
 * - refetchOnReconnect: true - Refetch when connection is restored (data consistency)
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Providers>
          <Layout>
            <Router />
          </Layout>
        </Providers>
      </BrowserRouter>
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
}
